export const blockIconsNotificationPower = (
	<span className='material-symbols-outlined'>power</span>
);
